import orderReducer from "./orderReducer";

export const orderReducers = {
  order: orderReducer,
};
